import React, { useCallback, useEffect, useState } from 'react';

import { useSelector } from 'react-redux';

import { users } from 'api/endpoints/user-management';
import LayoutMain from 'components/layouts/LayoutMain';
import { OPTION_PAGINATION } from 'constants/index';
import { TEXT_USER_LIST } from 'constants/string/texts';
import UsersListHeader from 'pages/Users/List/UsersHeader';
import UserPagination from 'pages/Users/List/UsersPagination';
import UsersSearch from 'pages/Users/List/UsersSearch';
import UsersTable from 'pages/Users/List/UsersTable';
import { convertToQueryString } from 'utils/helper';

const User = () => {
  const { me } = useSelector((state) => state.auth);

  const [options, setOptions] = useState({ keyword: null, ...OPTION_PAGINATION });
  const [sort, setSort] = useState([]);
  const [listUsers, setListUsers] = useState([]);
  const [loading, setLoading] = useState(false);

  // SEARCH
  const onChangeKeyword = (keyword) => {
    if (keyword !== options.keyword) {
      setOptions((prevState) => {
        return { ...prevState, keyword: keyword };
      });
    }
  };

  // PAGINATION
  const onPageChange = (e) => {
    if (e !== options.page) {
      setOptions((prevState) => {
        return { ...prevState, page: e };
      });
      return true;
    }

    return false;
  };

  // SORT
  const onSortChange = (e) => {
    setSort(() => e);
  };

  // MUNICIPALITY
  const onChangeMunicipality = (e) => {
    if (e !== options.municipality_code) {
      setOptions((prevState) => {
        return { ...prevState, ...e };
      });
    }
  };

  /**
   * @name handleSort
   * @returns {string[]}
   * @example ['created_at']
   * @example ['-created_at']
   */
  const handleSort = () => {
    return (
      sort.map((item) => {
        return item.desc ? `-${item.id}` : item.id;
      }) || []
    );
  };

  const handleGetUsers = async () => {
    const sortHandle = handleSort().filter((item) => item !== 'link' && item !== '-link');
    const queryString = convertToQueryString({
      keyword: options.keyword,
      sort_by: sortHandle,
      page: options.page,
      municipality_code: options.municipality_code,
    });
    setLoading(true);
    try {
      await users(queryString)
        .then((response) => {
          const totalPage = Math.ceil(response.total / response.page_size);
          const page = response.page > totalPage ? (totalPage === 0 ? 1 : totalPage) : options.page;

          setListUsers(response?.data || []);
          setOptions((prevState) => {
            return {
              ...prevState,
              total: response.total,
              page_size: response.page_size,
              page: page,
            };
          });
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });
    } catch {
      setLoading(false);
    }
  };

  // GET DATA
  const getUsers = useCallback(async () => {
    if (me) {
      handleGetUsers();
    }
  }, [options.page, options.keyword, options.municipality_code, sort, me]);

  useEffect(() => {
    getUsers();
  }, [getUsers]);

  return (
    <>
      <LayoutMain>
        <section id="question-list">
          <h1 className="text-2xl font-bold text-black/85">{TEXT_USER_LIST.TITLE}</h1>
          <UsersListHeader options={options} onChange={onChangeMunicipality} />
          <UsersSearch options={options} onSubmit={onChangeKeyword} />
          <div className={`w-full mt-4 ${options.total > 0 ? 'min-h-164.75' : ''}`}>
            <UsersTable
              data={listUsers}
              setSort={onSortChange}
              reloadData={handleGetUsers}
              onPageChange={onPageChange}
              sort={sort}
              page={options.page}
              keyword={options.keyword}
              isFilter={!!options.keyword || options.municipality_code}
            />
          </div>
          {options.total > 0 && <UserPagination options={options} onPageChange={onPageChange} loading={loading} />}
        </section>
      </LayoutMain>
    </>
  );
};

export default React.memo(User);
